import React from "react";
import PropTypes from "prop-types";
import RSDropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownUtils, {
  dropdownHasSubmenus,
  getMaxHeight
} from "../../lib/dropdownUtils";

const DropdownMenu = ({ rightAligned, ...props }) => {
  const { items } = props;
  const hasSubmenus = dropdownHasSubmenus(items);

  return (
    <RSDropdownMenu
      tag={hasSubmenus ? "ul" : "div"}
      right={rightAligned}
      style={
        !hasSubmenus
          ? { maxHeight: getMaxHeight(props), overflowY: "auto" }
          : { overflow: "visible", maxHeight: "none" }
      }
    >
      {new DropdownUtils(hasSubmenus).renderDropdownItems(props)}
    </RSDropdownMenu>
  );
};

DropdownMenu.propTypes = {
  maxMenuHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rightAligned: PropTypes.bool,
  items: PropTypes.array
};

DropdownMenu.displayName = "OrionDropdownMenu";

export default DropdownMenu;
